import { computed } from 'vue';
import { rawDynamicImport } from '@app/helpers/memberships/section';
import { data } from '@app/booking/state/store'

export default function(validate, form){
    return {
        title     : 'Extras',
        component : rawDynamicImport(() => import('@app/booking/components/form/stages/extras/Extras.vue')),
        visible   : computed(() => data.event.details.value?.options?.length > 0),
        isValid   : computed(
            () => true //Extras aren't required
        ),
        data: computed(
            () => ({
                options: form.value.options.map((option) => ({
                    quantity       : form.value.ticket?.quantity,
                    id             : option?.id,
                    cost           : option?.cheapest_price?.price,
                    event_price_id : option?.cheapest_price?.id,
                }))
            })
        ),
    }
}